import React from "react";
import {useSelector} from "react-redux";
import {PropagateLoader} from "react-spinners";
import {css} from "@emotion/core";

const Loader = () => {
    const isLoading = useSelector(state => {
        return state.setting.isLoading
    });
    const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  width:fit-content;
`;

    return (
        <div className={"sa-modal-bg loader "+ (!isLoading && 'hide')}>
            <div className="sa-modal-bg-inner">
                <div className="container">
                    <div className="sweet-loading">
                        <PropagateLoader
                            css={override}
                            size={20}
                            color={"#003847"}
                            loading={true}
                        />
                    </div>
                </div>

            </div>
        </div>

    )
};

export default Loader
